<template>
  <v-navigation-drawer
    v-model="drawer"
    :color="color"
    :expand-on-hover="expandOnHover"
    :mini-variant="miniVariant"
    :right="right"
    app
    dark
    class="drawer-gradient"
  >
    <v-list nav class="py-0">
      <router-link to="/dashboard">
        <v-list-item two-line>
          <v-img
          src="~@/assets/logo-viva-dark.png"
          aspect-ratio="1"
          max-height="100"
          contain
          class="mt-3 mb-3"
        ></v-img>
        </v-list-item>
      </router-link>

      <v-divider class="mb-3"></v-divider>

      <fragment v-for="item in items" :key="item.title">
        <v-list-group
          v-if="item.children && item.children.length > 1"
          :prepend-icon="item.icon"
          v-admin="item.admin"
        >
          <template v-slot:activator>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>
          <v-list-item
            v-for="child in item.children"
            :key="child.title"
            :to="child.link"
            v-admin="item.admin"
          >
            <v-list-item-content>
              <v-list-item-title class="body-1 font-weight-light">{{ child.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item v-else :to="item.link" v-admin="item.admin">
          <v-icon class="mr-3">{{ item.icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title class="body-1 font-weight-light">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </fragment>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      drawer: null,
      items: [
        {
          title: "Home",
          icon: "mdi-chart-areaspline",
          link: { name: "dashboard" }
        },
        {
          title: "Solicitar Reembolso",
          icon: "mdi-ticket",
          link: { name: "rescue-codes.validate" },
        },
        {
          title: "Reembolsos",
          icon: "mdi-wallet",
          link: { name: "refunds" },
          admin: true
        },
        {
          title: "Pesquisas de satisfação",
          icon: "mdi-ballot",
          link: { name: "surveys" },
          admin: true
        },
        {
          title: "Cadastro",
          icon: "mdi-account-tie",
          admin: true,
          children: [
            {
              title: "Experiências",
              link: { name: "experiences" },
            },
            {
              title: "Contas Bancárias",
              link: { name: "bankAccounts" },
            },
            {
              title: "Filiais",
              link: { name: "branchs" },
            },
          ]
        },
        {
          title: "Usuários",
          icon: "mdi-account-group",
          link: { name: "users" },
          admin: true
        },
      ],
      color: "primary",
      colors: ["primary", "blue", "success", "red", "teal"],
      right: false,
      miniVariant: false,
      expandOnHover: false,
      background: false
    };
  }
};
</script>

<style lang="scss">
.drawer-gradient {
  //background: linear-gradient(var(--v-primary-base), var(--v-primary-lighten2));
  background: url("~@/assets/bg-menu.png") top center repeat #666;
}

.v-list-item__icon:first-child {
  margin-right: 12px !important;
}
</style>
